import { useState, useEffect } from 'react';

const DEFAULT_FLAGS = {
  eventModals: true,
  minimap: true,
  zoomControls: true,
  quickJump: true,
  autoPlay: true,
  keyboardShortcuts: true, // Always enabled
};

const STORAGE_KEY = 'careerTimelineFeatures';

export function useFeatureFlags() {
  const [flags, setFlags] = useState(() => {
    // Load from localStorage on mount
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return { ...DEFAULT_FLAGS, ...JSON.parse(stored) };
      }
    } catch (error) {
      console.error('Error loading feature flags:', error);
    }
    return DEFAULT_FLAGS;
  });

  // Save to localStorage whenever flags change
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(flags));
    } catch (error) {
      console.error('Error saving feature flags:', error);
    }
  }, [flags]);

  const toggleFlag = (flagName) => {
    setFlags(prev => ({
      ...prev,
      [flagName]: !prev[flagName]
    }));
  };

  const resetToDefault = () => {
    setFlags(DEFAULT_FLAGS);
  };

  return { flags, toggleFlag, resetToDefault };
}
